import { inject, Injectable } from '@angular/core';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';

import { PatientGroupsState, PatientGroupsStore } from './patient-groups.store';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'rank_order',
  sortByOrder: Order.ASC,
})
export class PatientGroupsQuery extends QueryEntity<PatientGroupsState> {
  protected store: PatientGroupsStore;

  constructor() {
    const store = inject(PatientGroupsStore);

    super(store);

    this.store = store;
  }
}
